import { formatString } from '@/lib/format-string';
import { cn } from '@/lib/utils';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import Price from '../Price';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';

const RelatedProducts = props => {
  const { hotProductData, className, title = "What's Hot" } = props;

  if (hotProductData.length === 0) {
    return null;
  }

  return (
    <div className={cn('mx-auto my-[40px] max-w-site lg_my-[80px]', className)}>
      <h2 className='px-[12px] font-teko-medium text-[30px] uppercase leading-none lg_px-0 lg_text-[40px]'>{title}</h2>

      <div className='mt-5'>
        {/* Mobile Carousel - visible only on small screens */}
        <div className='block sm:hidden'>
          <MobileCarousel hotProductData={hotProductData} />
        </div>
        
        {/* PC Grid - visible only on larger screens */}
        <div className='hidden sm:grid lg_grid-cols-4 lg_gap-x-[27px]'>
          <>
            {hotProductData.map(x => {
              const smallImage = x.small_image?.url;
              const hoverImage = x.hover_image;
              const href = `/${x.url_key}.html`;
              const finalPriceValue = x.price_range?.maximum_price?.final_price?.value;
              const currency = x.price_range?.maximum_price?.final_price?.currency;

              return (
                <div key={x.id}>
                  <ProductCard
                    href={href}
                    smallImage={smallImage}
                    hoverImage={hoverImage}
                    name={x.name}
                    serialName={x.serial_name}
                    currency={currency}
                    finalPriceValue={finalPriceValue}
                  />
                </div>
              );
            })}
          </>
        </div>
      </div>
    </div>
  );
};

const MobileCarousel = props => {
  const { hotProductData } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [api, setApi] = useState(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  useEffect(() => {
    if (!api) return;

    const onSelect = emblaApi => {
      if (!emblaApi) return;

      setSelectedIndex(emblaApi.selectedScrollSnap());
      setCanScrollPrev(api.canScrollPrev());
      setCanScrollNext(api.canScrollNext());
    };

    onSelect(api);
    api.on('reInit', onSelect).on('select', onSelect);
  }, [api]);

  return (
    <>
      <Carousel
        opts={{ align: 'start' }}
        setApi={setApi}
        className='pl-3 lg_pl-0'
      >
        <CarouselContent className='-ml-5'>
          {hotProductData.map((x, i, arr) => {
            const smallImage = x.small_image?.url;
            const hoverImage = x.hover_image;
            const href = `/${x.url_key}.html`;
            const finalPriceValue = x.price_range?.maximum_price?.final_price?.value;
            const currency = x.price_range?.maximum_price?.final_price?.currency;
            const isLastOne = i === arr.length - 1;

            return (
              <CarouselItem
                key={x.id}
                className={clsx(isLastOne ? 'basis-[342px] pl-5 pr-3' : 'basis-[330px] pl-5')}
              >
                <ProductCard
                  href={href}
                  smallImage={smallImage}
                  hoverImage={hoverImage}
                  name={x.name}
                  serialName={x.serial_name}
                  currency={currency}
                  finalPriceValue={finalPriceValue}
                />
              </CarouselItem>
            );
          })}
        </CarouselContent>
      </Carousel>
      {(canScrollPrev || canScrollNext) && hotProductData.length > 1 ? (
        <div className='px-3'>
          <div className='relative mt-5 h-[1px] bg-e0e0e0  '>
            <div
              className='absolute left-0 top-1/2 h-[3px] -translate-y-1/2 bg-black transition-[width] duration-2xl ease-linear'
              style={{
                width: `${Math.min(100, Math.floor(((selectedIndex + 1) / hotProductData.length) * 100))}%`,
              }}
            ></div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const ProductCard = props => {
  const { href, smallImage, hoverImage, name, serialName, currency, finalPriceValue } = props;
  return (
    <>
      <Link
        className='block'
        href={href}
      >
        <span className='group relative bg-f9f9f9 block'>
          <Image
            src={smallImage}
            width={1265}
            height={1600}
            alt={name}
            loader={({ src }) => src}
            className='h-auto w-full'
          />
          {/* {hoverImage ? (
            <Image
              src={hoverImage}
              width={1265}
              height={1600}
              alt={name}
              loader={({ src }) => src}
              className='absolute left-0 top-0 z-[1] h-auto w-full opacity-0 transition-opacity duration-2xl ease-linear lg_group-hover_opacity-100 '
            />
          ) : null} */}
        </span>
      </Link>
      <div className='mt-2 lg_mt-2.5'>
        {serialName ? (
          <h3 className=' font-teko-medium text-[22px] uppercase leading-8  lg_leading-[37px]'>{serialName}</h3>
        ) : null}
        <Link
          className=' block max-w-max font-roboto-light text-[16px] leading-[26px] lg_font-roboto-regular lg_text-[18px] lg_leading-[30px]'
          href={href}
        >
          <h3>{formatString(name)}</h3>
        </Link>
      </div>

      <div className='mt-4 font-roboto-medium text-[18px] font-medium leading-[21px] lg_mt-5 lg_text-[20px] lg_leading-[28px]'>
        <Price
          currencyCode={currency}
          value={finalPriceValue}
        />
      </div>
    </>
  );
};

export default RelatedProducts;
